import { render } from "./information.vue?vue&type=template&id=316cb957&scoped=true"
import script from "./information.vue?vue&type=script&lang=js"
export * from "./information.vue?vue&type=script&lang=js"

import "./information.vue?vue&type=style&index=0&id=316cb957&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\jll-web-xintan\\official-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316cb957"]])

export default __exports__